import {
    faDrawSquare,
    faLocationDot,
    faPenLine,
    faScribble,
} from "@fortawesome/pro-regular-svg-icons";

const measureShapes = [
    { value: "Line", label: "Ligne", icon: faPenLine },
    { value: "Surface", label: "Surface", icon: faDrawSquare },
    { value: "Polyline", label: "Polyligne", icon: faScribble },
    { value: "Point", label: "Point", icon: faLocationDot },
] as const;

export default measureShapes;
